
import { mapState, mapActions, mapGetters } from "vuex";
import paymentSuccessDialog from "../dialogs/payment-success-dialog.vue";
import razorpay from "../../mixins/razorpay";
export default {
  components: { paymentSuccessDialog },
  mixins: [razorpay],
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$nuxt.$on("make-payment", this.hanldeInitPayment);
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "businessDetails"]),
    ...mapState("auth", ["user"])
  },
  beforeDestroy() {
    this.$nuxt.$off("make-payment");
  },
  methods: {
    ...mapActions("payment", [
      "initPayment",
      "paymentSuccess",
      "paymentFailed",
      "getInvoices"
    ]),
    async hanldeInitPayment(invoiceId) {
      await this.addRazorpayScript();
      this.initPayment({ invoice_id: invoiceId, isAndroid: this.isAndroid() })
        .then(({ data }) => {
          this.$nuxt.$emit("order-placed");
          const dataAttributes = data?.razor_pay_order?.attributes;
          if (dataAttributes) {
            let options = {
              key: data.razor_pay_key,
              amount: Math.round(dataAttributes.amount * 1000),
              currency: this.locationDetails.location_currency,
              name: "Foaps",
              description: dataAttributes.receipt,
              image: "https://v2.foaps.co/v2/icon.svg",
              order_id: dataAttributes.id,

              prefill: {
                name: this.businessDetails.name || "",
                email: this.user.email || "email@foaps.co",
                contact:
                  this.user?.phone?.country_code + this.user?.phone?.number ||
                  "+919999999999"
              },
              notes: {
                address: this.locationDetails.address
              },
              theme: {
                color: "#FF6B28"
              }
            };

            this.proceedRazorpayPayment(
              options,
              this.razorpayPaymentSuccess,
              this.handlePaymentFailure
            );
          } else {
            this.handlePaymentFailure("Something went wrong!");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$nuxt.$emit("show-error-toast", err);
          this.$nuxt.$emit("payment-failed");
        });
    },
    razorpayPaymentSuccess(response) {
      if (typeof response === "string") response = JSON.parse(response);
      this.paymentSuccess(response)
        .then((data) => {
          this.getInvoices();
          this.$nuxt.$emit("payment-success");
          this.dialog = true;
        })
        .catch((err) => {
          this.$nuxt.$emit("show-error-toast", err);
        });
    },
    handlePaymentFailure(response) {
      if (typeof response === "string") response = JSON.parse(response);
      this.paymentFailed(response)
        .then((data) => {
          this.$nuxt.$emit(
            "show-error-toast",
            response?.error?.description || response
          );
          this.$nuxt.$emit("payment-failed");
        })
        .catch((err) => {
          this.$nuxt.$emit("show-error-toast", err);
        });
    }
  }
};
